import { TasksAndFollowupsListView } from '../components/TasksAndFollowupsListView';

export function CRMTasksPage() {
  return <TasksAndFollowupsListView initialType="task" />;
}
